import {
  Avatar,
  Text,
  HStack,
  SkeletonCircle,
  SkeletonText,
  VStack
} from "@chakra-ui/react";
import { useContext } from "react";

import { ContributionContext } from "../context";

export function Header({ hideActionList }: { hideActionList?: boolean }) {
  const {
    username,
    userAvatarSrc,
    isLoaded,
    contributionTime,
    showMoreOptions,
    actionList
  } = useContext(ContributionContext);

  if (!isLoaded) {
    return (
      <HStack justify="space-between">
        <HStack w="full">
          <SkeletonCircle w="2.75rem" h={10} />
          <VStack w="full" align="start" cursor="default">
            <SkeletonText w="80%" noOfLines={1} skeletonHeight={2} />
            <SkeletonText w="50%" noOfLines={1} skeletonHeight={1} />
          </VStack>
        </HStack>
      </HStack>
    );
  }

  return (
    <HStack justify="space-between">
      <HStack>
        <Avatar
          name={username}
          src={userAvatarSrc}
          aria-hidden="true"
          data-testid="card-avatarImage"
        />
        <VStack w="full" spacing={0} align="start" cursor="default">
          <Text
            noOfLines={1}
            fontSize="sm"
            fontWeight="semibold"
            data-testid="card-usernameText"
          >
            {username}
          </Text>
          <Text
            fontSize="xs"
            noOfLines={1}
            fontWeight="medium"
            data-testid="card-contributionTimeText"
          >
            {contributionTime}
          </Text>
        </VStack>
      </HStack>
      {isLoaded && !hideActionList && (
        <HStack gap={2}>{showMoreOptions && actionList}</HStack>
      )}
    </HStack>
  );
}
